import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Tabs, Tab, Button, Offcanvas } from 'react-bootstrap';
import transaction from "../../actions/transaction";
import {ReactComponent as InfoSvg} from './../../assets/icons/svg/info.svg';
import {ReactComponent as UserSvg} from './../../assets/icons/svg/user.svg';
import {ReactComponent as KeySvg} from './../../assets/icons/svg/keys.svg';
import {ReactComponent as UserDeleteSvg} from './../../assets/icons/svg/user-delete.svg';
import ListPickup from "../../components/ListPickup";
import { toast } from 'react-toastify';
import moment from 'moment';
import auths from "../../actions/auth";

export default function Profile() {
   const navigate = useNavigate();
   const [auth, setAuth] = useState([]);
   const [showResp, setShowResp] = useState(false);
   const handleCloseResp = () => setShowResp(false);
   const handleShowResp = () => setShowResp(true);
   const [loading, setLoading] = useState(true);
   const edit = useLocation();
   
  useEffect(() => {
      auths.actions.get_users().then((res)=>{
         setAuth(res?.data)
         sessionStorage.setItem('profile', JSON.stringify(res?.data))
         setLoading(false)
      });

      if(edit.state && edit.state.edit){
         handleShowResp()
      }
  },[])

  const logout = () => {
   sessionStorage.setItem('token', '')
   sessionStorage.setItem('user_data', [])
   sessionStorage.setItem('profile', [])
   toast.success('Berhasil Keluar');
   navigate('/')
  }

  const contactAdmin = () => {
   window.open(`https://wa.me/+6281958464688/?text=Halo Admin`, '_blank')
  }
  
  return (
   <div className="bg-light vh-100">
      <div className="fixed-top bg-transparent header">
         <div className="text-center fw-semibold text-light">
               Profile
         </div>
         <Button className="btn btn-icon btn-light btn-sm btn-radius btn-nav-back" onClick={() => navigate('/home')}>
            <i className="ph-arrow-left text-success"></i>
         </Button>
      </div>
      <div className="bg-radial-green">
         <div className="bg-radial-embed-circle">
            <div className="text-center pt-4">
               <UserSvg className="mb-4"/>
               <h3 className={"text-light mb-1 " + (loading ? "skeleton" : '')}>{auth?.name}</h3>
               <div className={"text-smooth " + (loading ? "skeleton" : '')}>{auth?.email}</div>
            </div>
         </div>
      </div>

      <div className="list px-4" style={{paddingBottom:'130px'}}>
         <div className="account py-4 border-bottom" onClick={() => handleShowResp()}>
            <div className="fw-semibold text-body mb-2">Akun</div>
            <div className="d-flex align-items-center justify-content-between">
               <div className="d-flex align-items-center">
                  <div className="btn-success p-2 btn-radius me-3">
                     <UserSvg style={{width:'30px', height:'30px', padding:'5px'}}/>
                  </div>
                 <div className="text-muted">Profile</div>
               </div>
               <i className="ph-caret-right"></i>
            </div>
         </div>
         <div className="account py-4 pb-5">
            <div className="fw-semibold text-body mb-2">Keamanan</div>
            <div className="d-flex align-items-center justify-content-between mb-3" onClick={() => navigate('/profile/change-password')}>
               <div className="d-flex align-items-center">
                  <div className="btn-success p-2 btn-radius me-3">
                     <KeySvg style={{width:'30px', height:'30px', padding:'5px'}}/>
                  </div>
                 <div className="text-muted">Ubah Kata Sandi</div>
               </div>
               <i className="ph-caret-right"></i>
            </div>
         </div>
      </div>

      <div className="d-grid gap-2 fixed-bottom p-4 bg-light">
         <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => contactAdmin()} >
            HUBUNGI ADMIN
         </Button>
         <Button className="btn-auth rounded-pill p-3" variant="outline-success" onClick={() => logout()} >
            KELUAR
         </Button>
      </div>

      <Offcanvas show={showResp} onHide={handleCloseResp} placement="bottom" className="h-auto">
         <Offcanvas.Header>
            <Offcanvas.Title className="w-100">
               <div className="d-flex align-items-center justify-content-between">
                  Detail Profile
                  <small className="text-success px-2" onClick={() => navigate('/profile/edit')}>Edit</small>
               </div>
            </Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-5">
            <table className="table-listed">
               <tbody>
                  <tr>
                     <td className="w-50 text-muted">Nama</td>
                     <td className="w-50 fw-semibold text-end">{auth?.name}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Email</td>
                     <td className="w-50 fw-semibold text-end">{auth?.email}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Jenis Nasabah</td>
                     <td className="w-50 fw-semibold text-end">{auth?.type === 'person' ? 'Perorangan':'Non-Perorangan'}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">No Handphone</td>
                     <td className="w-50 fw-semibold text-end">{auth?.phone}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Jumlah Anggota Kelurga yang tinggal bersama</td>
                     <td className="w-50 fw-semibold text-end">{auth?.total_family_member}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Mitra Terdaftar</td>
                     <td className="w-50 fw-semibold text-end">
                        {auth.partners && auth.partners.map((data, keys)=>{
                           return <span key={keys}>{data?.name} {keys+1 !== auth?.partners?.length ? ', ' : ''}</span>
                        })}
                     </td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Tanggal Terdaftar</td>
                     <td className="w-50 fw-semibold text-end">{moment(new Date(auth?.created_at)).format('DD/MM/YYYY')}</td>
                  </tr>
                  <tr>
                     <td className="w-50 text-muted">Alamat Rumah</td>
                     <td className="w-50 fw-semibold text-end">{auth?.address + ', ' + auth?.village?.name+ ', ' + auth?.district?.name+ ', ' + auth?.city?.name+ ', ' + auth?.province?.name}</td>
                  </tr>
               </tbody>
            </table>
         </Offcanvas.Body>
      </Offcanvas>
   </div>
  );
}